import { ArsContextState, IArsActionRemoveWhereClause } from "../interface";
import { removeWhereClause } from "../removeWhereClause";
import { addPatchToStack } from "./arsc_patchHelpers";

/**
 * Removes a specific sub-clause from a where clause path.
 *
 * @param state - Current ARS context state
 * @param action - Remove-where-clause action
 * @returns Updated state with patch metadata when data changed
 */
export const arsc_removeWhereClause = <T>(
  state: ArsContextState<T>,
  action: IArsActionRemoveWhereClause,
): ArsContextState<T> => {
  const removedState = removeWhereClause(state, action.dataPath, action.id);
  if (removedState !== state) {
    return addPatchToStack(state, removedState);
  }

  return state;
};
